var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHonda(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.35,
    height: 46.84,
    viewBox: "0 0 53.35 46.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#e82934}.cls-2{fill:#ce1c35}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "honda_red",
    transform: "translate(-1.447 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    d: "M48.368 11.5l-3.1 38.9h-5.656a15.074 15.074 0 0 0-1.819-6.632 2.778 2.778 0 0 0-1.078-1.094 10.347 10.347 0 0 0-4.782-.957 10.347 10.347 0 0 0-4.782.957 2.784 2.784 0 0 0-1.078 1.094 15.074 15.074 0 0 0-1.817 6.632H18.6l-3.1-38.9h4.109c1.819 10.665 3.233 16.34 5.658 20.989a3.3 3.3 0 0 0 2.425 1.846 21.11 21.11 0 0 0 4.243.273 28.274 28.274 0 0 0 4.243-.273 3.666 3.666 0 0 0 2.422-1.846c2.427-4.649 3.841-10.255 5.66-20.989z",
    className: "cls-1",
    "data-name": "Trazado 354",
    transform: "translate(-4.002 -1.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_355",
    d: "M33.172 55.7a11.757 11.757 0 0 0-5.152.97 2.913 2.913 0 0 0-1.161 1.108A14.543 14.543 0 0 0 24.9 64.5h2.685a14.543 14.543 0 0 1 1.959-6.718A2.908 2.908 0 0 1 30.7 56.67a10.733 10.733 0 0 1 3.773-.97z",
    className: "cls-2",
    "data-name": "Trazado 355",
    transform: "translate(-7.19 -15.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_356",
    d: "M26.255 34.179a21.728 21.728 0 0 0 4.281.27h1.224a14.476 14.476 0 0 1-2.99-.27 3.692 3.692 0 0 1-2.447-1.825c-2.447-4.6-3.874-10.14-5.709-20.754H18.1c1.835 10.546 3.262 16.157 5.709 20.754a3.692 3.692 0 0 0 2.446 1.825z",
    className: "cls-2",
    "data-name": "Trazado 356",
    transform: "translate(-4.257 -1.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    d: "M59.29 11.5L56 50.473h2.646l3.29-38.973z",
    className: "cls-2",
    "data-name": "Trazado 357",
    transform: "translate(-17.149 -1.566)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    d: "M40.747 6h-25.28C1.484 6 1.277 10.34 1.484 15.644l1.1 28.518c.138 4.822 3.789 8.679 8.128 8.679h34.581c4.34 0 7.99-3.857 8.2-8.679l1.033-28.518C54.73 10.34 54.523 6 40.747 6zm9.644 9.506l-1.034 28.517a4.32 4.32 0 0 1-4.064 4.34H10.714a4.369 4.369 0 0 1-4.064-4.34L5.617 15.506a5.3 5.3 0 0 1 1.24-3.72 3.551 3.551 0 0 1 2.686-1.24h36.99a3.551 3.551 0 0 1 2.686 1.24 5.152 5.152 0 0 1 1.171 3.72z",
    className: "cls-1",
    "data-name": "Trazado 358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    d: "M10.567 12.5H8.03a3.806 3.806 0 0 0-2.83 1.246 5.169 5.169 0 0 0-1.3 3.737l1.16 28.649a4.435 4.435 0 0 0 4.277 4.36h2.537a4.486 4.486 0 0 1-4.277-4.36l-1.09-28.58a5.169 5.169 0 0 1 1.3-3.737 3.562 3.562 0 0 1 2.76-1.315z",
    className: "cls-2",
    "data-name": "Trazado 359",
    transform: "translate(-.696 -2.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    d: "M57.539 6H55c14.506 0 14.723 4.34 14.506 9.644l-1.16 28.518a8.914 8.914 0 0 1-8.631 8.679h2.539a8.914 8.914 0 0 0 8.631-8.679l1.16-28.518C72.262 10.34 72.044 6 57.539 6z",
    className: "cls-2",
    "data-name": "Trazado 360",
    transform: "translate(-17.285)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonda);
export default __webpack_public_path__ + "static/media/honda.7399661d1a00887def308e42f267e6e1.svg";
export { ForwardRef as ReactComponent };